@if (hasDrivers()) {
  <div class="ai-drivers" *transloco="let t; prefix: 'ai-assistant'">
    @if (title()) {
      <div class="ai-drivers__title">{{ title() }}</div>
    }
    @if (target()) {
      <div class="ai-drivers__target">{{ t('drivers-target', { target: target() }) }}</div>
    }
    <div class="ai-drivers__list">
      @for (driver of drivers(); track $index) {
        <div class="ai-drivers__item">
          <div class="ai-drivers__header">
            <span class="ai-drivers__name">{{ driver.driver }}</span>
            <span class="ai-drivers__importance">{{ formatImportance(driver.importance) }}</span>
          </div>
          <div class="ai-drivers__bar-track">
            <div
              class="ai-drivers__bar"
              [class]="barClass(driver)"
              [style.width.%]="barWidth(driver)"
            ></div>
          </div>
          <div class="ai-drivers__explanation">{{ driver.explanation }}</div>
        </div>
      }
    </div>
  </div>
}
